import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import AreaApi from '@/api/area'
import VisitorApi from '@/api/visitor'
import { nameLength } from '@/config/global'
import {
	caseNoReg,
	taskRequest,
	contactPhonePattern,
	mobilePhone,
} from '@/utils/regExp'
import { checkCarNo, hasVisitor, debounce } from '@/utils/util'
const debounceSearch = debounce(300)
const debounceUpload = debounce(100)
const pointIdMap: any = {}
const MAX_FILE_NUM = 10
const MAX_FILE_SIZEM = 10

@Component({})
export default class AddTaskMixin extends Vue {
	public nameLength = nameLength
	public taskRequest: any = taskRequest
	public contactPhonePattern = contactPhonePattern
	public caseNoReg: any = caseNoReg
	public mobilePhone = mobilePhone
	public hasVisitor: any = hasVisitor
	public addForm: any = {}
	public addLoading = false
	public uploading = false
	public noData = false
	public searchArea: any = []
	public fileIdMap: any = {}
	public fileListMap: any = {}
	public sameWithPublisher = false
	public checkedTypeList: string[] = []
	public MAX_POINT_NUM = 10

	public caseWaring: '' | 'warning' | 'success' | 'error' | 'validating' = ''
	public caseHelpMes = ''

	@Prop()
	public data!: any

	@Prop()
	public riskDisposal!: any

	@Watch('$store.state.setting', { immediate: true })
	private onSettingChange() {
		if (this.$store.state.setting) {
			this.$nextTick(() => {
				this.$store.state.setting.subTasktypeList.forEach((item: any) => {
					pointIdMap[item.key] = 0
					// 初始化核查重点增加/删除下标
					this.addForm.getFieldDecorator(`taskMap[${item.key}].pointIds`, {
						initialValue: [pointIdMap[item.key]],
						preserve: true,
					})
					this.addForm.getFieldDecorator(`taskMap[${item.key}].urgentTask`, {
						preserve: true,
					})

					// 上传文件初始化
					this.$set(this.fileListMap, item.key, [])
					this.$set(this.fileIdMap, item.key, [])
				})
			})
		}
	}

	public get isRiskDisposal() {
		return !!this.riskDisposal
	}

	public onCheckUrgent(e: Event, checkedType: string) {
		const target = e.target as any
		this.addForm.setFieldsValue({
			[`taskMap[${checkedType}].urgentTask`]: target.checked ? '1' : '0',
		})
	}

	public resetFile(checkedType: string) {
		this.fileListMap[checkedType] = []
		this.fileIdMap[checkedType] = []
	}

	public resetPoint(checkedType: string) {
		pointIdMap[checkedType] = 0
		this.addForm.setFieldsValue({
			[`taskMap[${checkedType}].pointIds`]: [pointIdMap[checkedType]],
		})
	}

	public addPoint(value: string, id: number) {
		let currentIds = this.addForm.getFieldValue(`taskMap[${value}].pointIds`)
		currentIds.splice(currentIds.indexOf(id) + 1, 0, ++pointIdMap[value])
		this.addForm.setFieldsValue({
			[`taskMap[${value}].pointIds`]: currentIds,
		})
	}

	public removePoint(value: string, id: number) {
		let currentIds = this.addForm.getFieldValue(`taskMap[${value}].pointIds`)
		currentIds.splice(currentIds.indexOf(id), 1)
		this.addForm.setFieldsValue({
			[`taskMap[${value}].pointIds`]: currentIds,
		})
	}

	public resetPage() {
		this.sameWithPublisher = true
		this.setPublisher()
		this.addForm.resetFields()
	}

	public uploadFileList(fileList: any, checkedType: number) {
		if (fileList.length + this.fileListMap[checkedType].length > MAX_FILE_NUM) {
			this.$message.error(`上传单证文件个数限制${MAX_FILE_NUM}个`)
			return
		}
		for (let i = 0; i < fileList.length; i++) {
			let currentFile = fileList[i]
			if (currentFile.size > MAX_FILE_SIZEM * 1024 * 1024) {
				this.$message.error(`${currentFile.name}文件大小超过${MAX_FILE_SIZEM}M`)
				return
			}
		}

		this.uploading = true
		const hide: any = this.$message.loading('上传中...', 0)
		let num = 0
		for (const file of fileList) {
			const formData = new FormData()
			formData.append('filecontent', file)

			VisitorApi.uploadFile({ formData })
				.then((res: any) => {
					num++
					this.$set(this.fileListMap, checkedType, [
						...this.fileListMap[checkedType],
						file,
					])
					let fileItem = {
						fileId: res.data.fileId,
						fileName: file.name,
						uid: file.uid,
					}
					this.$set(this.fileIdMap, checkedType, [
						...this.fileIdMap[checkedType],
						fileItem,
					])
					if (num === fileList.length) {
						hide()
						this.uploading = false
						this.$message.success('上传完成')
					}
					// this.$message.success(`${file.name}上传成功`)
				})
				.catch((err: any) => {
					num++
					this.$message.error(`${file.name}上传失败`)
					if (num === fileList.length) {
						hide()
						this.uploading = false
						this.$message.success('上传完成')
					}
				})
		}
	}

	public beforeUpload(file: any, fileList: any, checkedType: number) {
		debounceUpload(() => {
			this.uploadFileList(fileList, checkedType)
		})

		return false
	}

	public handleRemove(file: any, checkedType: number) {
		let index = this.fileListMap[checkedType].indexOf(file)
		this.fileListMap[checkedType].splice(index, 1)
		this.fileIdMap[checkedType].splice(index, 1)
	}

	public setPublisher() {
		this.$nextTick(() => {
			if (this.sameWithPublisher) {
				this.addForm.setFieldsValue({
					contact: this.$store.state.user.userInfo.name,
					contactPhone: this.$store.state.user.userInfo.mobile,
				})
			} else {
				this.addForm.setFieldsValue({
					contact: undefined,
					contactPhone: undefined,
				})
			}
		})
	}

	/*就诊地区输入搜索*/
	public areaSearch(value: any) {
		return new Promise((resolve: any, reject: any) => {
			debounceSearch(() => {
				AreaApi.searchArea(value).then((res: any) => {
					if (res.data.length) {
						this.noData = false
						this.searchArea = res.data.map((item: any) => {
							return {
								code: item.provCode + '-' + item.cityCode + '-' + item.areaCode,
								area: item.provName + '-' + item.cityName + '-' + item.areaName,
								cityName: item.cityName,
							}
						})
					} else {
						this.noData = true
						this.searchArea = []
					}
					resolve()
				})
			})
		})
	}

	public onWithPublisherChange(e: any) {
		this.sameWithPublisher = e.target.checked
		this.setPublisher()
	}

	public created() {
		this.addForm = this.$form.createForm(this)
		this.sameWithPublisher = true
		this.setPublisher()

		this.caseWaring = 'warning'
		this.caseHelpMes = '注: 如非本地承保案件，委派前建议先获取承保机构同意'
	}

	public checkCaseNo(rule: any, value: any, callback: Function) {
		var reg = /^[^\u4e00-\u9fa5]+$/
		if (!!value && !reg.test(value)) {
			this.caseWaring = 'error'
			this.caseHelpMes = '不能输入中文字符'
			return
		}
		this.caseWaring = 'warning'
		this.caseHelpMes = '注: 如非本地承保案件，委派前建议先获取承保机构同意'
		console.log('注: 如非本地承保案件，委派前建议先获取承保机构同意')
		return callback()
	}
}
